export const Phases = [
  { label: 'Acquisition', value: 'ACQUISITION' },
  { label: 'Finance', value: 'FINANCE' },
  { label: 'Procurement', value: 'PROCUREMENT' },
  { label: 'Development', value: 'DEVELOPMENT' },
  { label: 'Design', value: 'DESIGN' },
  { label: 'Construction', value: 'CONSTRUCTION' },
];
